import { render, staticRenderFns } from "./SelectableCard.vue?vue&type=template&id=5c569bc3&scoped=true&"
import script from "./SelectableCard.vue?vue&type=script&lang=js&"
export * from "./SelectableCard.vue?vue&type=script&lang=js&"
import style0 from "./SelectableCard.vue?vue&type=style&index=0&id=5c569bc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c569bc3",
  null
  
)

export default component.exports